(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dales-featured-services"] && !Shopify.designMode) return;
  try {
    
(function(){
function setup(){
if(!document.body.classList.contains('template-index'))return;
var root=document.getElementById('MainContent');
if(!root || root.dataset.dmDesktopOrderReady)return;
root.dataset.dmDesktopOrderReady='true';
var original=Array.from(root.children),desktop=window.matchMedia('(min-width:1025px)');
var ids=['shopify-section-dales_home_hero_in9N9z','shopify-section-61e50f79-caf8-4728-925b-4eea6d4c9a0b','shopify-section-banner_block_1_zYHBN7','shopify-section-16607763925fbd0265','shopify-section-dm_featured_services','shopify-section-dales_why_motorsport_HbzpLy','shopify-section-1576317106642'];
function arrange(){
var ordered=desktop.matches?ids.map(function(id){return original.find(function(node){return node.id===id;});}).filter(Boolean):original;
if(desktop.matches)ordered=ordered.concat(original.filter(function(node){return !ids.includes(node.id);}));
ordered.forEach(function(node,index){if(root.children[index]!==node)root.insertBefore(node,root.children[index] || null);});
}
desktop.addEventListener('change',arrange);
arrange();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
})();

  } catch(e) { console.error(e); }
})();
})();
